import type { VisibilityRuleMap } from '../types/featureVisibility.types';
import { F, type HomeFeatureKey } from '../types/features.keys';
import { and, isBrand, isNotOfflineMode } from './visibility.combinators';

export const homeVisibilityRules: Pick<VisibilityRuleMap, HomeFeatureKey> = {
  [F.home.brand]: and(isBrand, isNotOfflineMode),
};
